exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".insert[data-v-6f76cab2] {\n  opacity: 0;\n  display: grid;\n  place-content: center stretch;\n  padding: 0 0.5rem;\n}\n.insert.dropin[data-v-6f76cab2] {\n  opacity: 1;\n}\n.line[data-v-6f76cab2] {\n  height: 2px;\n  background: var(--clr-primary);\n}\n", ""]);

// exports
